import React, { useEffect } from 'react';
import MitraTelecaller from './components/MitraTelecaller';

const MitraTelecallerContainer = () => {

  useEffect(() => {
    
  }, []);

  return <MitraTelecaller/>
};

export default MitraTelecallerContainer;
